import { useEffect, useRef, useState } from 'react';
import { FaMicrophone, FaTrash } from 'react-icons/fa';
const AudioRecorder = ({
  ReturnAudio,
}: {
  ReturnAudio: (audio: string) => void;
}) => {
  const [permission, setPermission] = useState(false);
  const [stream, setStream] = useState<MediaStream | null>(null);

  const mediaRecorder = useRef<MediaRecorder | null>(null);
  const [recordingStatus, setRecordingStatus] = useState('inactive');
  const [audioChunks, setAudioChunks] = useState<Blob[]>([]);
  const [audio, setAudio] = useState('');
  const mimeType = 'audio/webm';

  useEffect(() => {
    getMicrophonePermission();
  }, []);

  const getMicrophonePermission = async () => {
    if ('MediaRecorder' in window) {
      try {
        const streamData = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        setPermission(true);
        setStream(streamData);
      } catch (err) {
        alert(err);
      }
    } else {
      alert('The MediaRecorder API is not supported in your browser.');
    }
  };

  const startRecording = async () => {
    if (stream === null) return;

    setRecordingStatus('recording');

    //create new Media recorder instance using the stream
    const media = new MediaRecorder(stream, { mimeType });
    //set the MediaRecorder instance to the mediaRecorder ref
    mediaRecorder.current = media;
    //invokes the start method to start the recording process
    mediaRecorder.current.start();
    const localAudioChunks: Blob[] = [];
    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === 'undefined') return;
      if (event.data.size === 0) return;
      localAudioChunks.push(event.data);
    };
    setAudioChunks(localAudioChunks);
  };

  const stopRecording = () => {
    if (mediaRecorder.current === null) return;

    setRecordingStatus('inactive');
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = () => {
      //creates a blob file from the audiochunks data
      const audioBlob = new Blob(audioChunks, { type: mimeType });
      //creates a playable URL from the blob file.
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudio(audioUrl);
      ReturnAudio(audioUrl);
      setAudioChunks([]);
    };
  };

  const handleDeleteAudio = () => {
    setAudio('');
    ReturnAudio('');
    setRecordingStatus('inactive');
  };

  return (
    <div>
      <div className="audio-controls">
        {!audio ? (
          <div className="flex flex-row items-center gap-2 max-w-min whitespace-nowrap py-2 px-4 border border-secondary-500 text-secondary-500 bg-white rounded-md cursor-pointer">
            <FaMicrophone />
            {!permission ? (
              <button onClick={getMicrophonePermission} type="button">
                Get Permission
              </button>
            ) : null}
            {permission && recordingStatus === 'inactive' && !audio ? (
              <button type="button" onClick={startRecording}>
                Start Record
              </button>
            ) : null}
            {permission && recordingStatus === 'recording' && !audio ? (
              <button type="button" onClick={stopRecording}>
                Stop Record
              </button>
            ) : null}
          </div>
        ) : (
          <div className="audio-container flex flex-row items-center gap-2">
            <audio src={audio} controls></audio>
            <div
              className="text-red-600 p-4 border-2 border-red-600 rounded-md cursor-pointer hover:bg-red-600/20"
              onClick={handleDeleteAudio}
            >
              <FaTrash />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default AudioRecorder;
